import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { message } from 'antd'
import LoginLogService from 'services/LoginLogService'

export const initialState = {
	loading: false,
	loginHistory: [],
	error: null,
}

export const getLoginHistory = createAsyncThunk(
	'loginHistory/get',
	async (userId = null, { rejectWithValue }) => {
		try {
			const response = await LoginLogService.getLogsHistory({ userId })
			return response.result
		} catch (err) {
			return rejectWithValue(err.response?.data?.message || 'Failed to fetch login history')
		}
	}
)

export const loginHistorySlice = createSlice({
	name: 'loginHistory',
	initialState,
	reducers: {
		showLoading: (state) => {
			state.loading = true
		},
		disableLoading: (state) => {
			state.loading = false
		},
		clearError: (state) => {
			state.error = null
		},
	},
	extraReducers: (builder) => {
		builder
			.addCase(getLoginHistory.pending, (state) => {
				state.loading = true
				state.error = null
				state.loginHistory = []
			})
			.addCase(getLoginHistory.fulfilled, (state, action) => {
				state.loading = false
				state.loginHistory = action.payload
			})
			.addCase(getLoginHistory.rejected, (state, action) => {
				state.loading = false
				state.error = action.payload
				message.error(action.payload, 5)
			})
	},
})

export const { showLoading, disableLoading, clearError } = loginHistorySlice.actions

export default loginHistorySlice.reducer
